import React from 'react';
import { styled } from '@mui/material/styles';
import { Theme } from '@mui/material/styles';
import { Styles } from '@mui/styles';
import {
	Button,
	Dialog,
	DialogTitle as MuiDialogTitle,
	DialogContent as MuiDialogContent,
	DialogActions as MuiDialogActions,
	IconButton,
	Typography,
	Link,
	Grid,
} from '@mui/material';

import { Close as CloseIcon } from '@mui/icons-material';
import { AdvertisementAsset, FileResult } from '@horasys/bellplus/common/types';
import UploadAsset from './UploadAsset';
import ContentLibraryModal from 'views/Advertising/ContentLibraryModal';

const PREFIX = 'ThumbnailSelector';

const classes = {
    root: `${PREFIX}-root`,
    root2: `${PREFIX}-root2`,
    root3: `${PREFIX}-root3`,
    closeButton: `${PREFIX}-closeButton`
};

const StyledMuiDialogTitle = styled(MuiDialogTitle)((
    {
        theme
    }
) => ({
    [`& .${classes.root3}`]: {
		margin: 0,
		padding: theme.spacing(2),
	},

    [`& .${classes.closeButton}`]: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	}
}));

interface Props {
	onAssetLoad: any;
	onAssetDelete: any;
	userAsset: AdvertisementAsset;
	linkName: string;
	disabled: boolean;
}

/**
 * Component for selecting thumbnail for selected video.
 */
const ThumbnailSelector = (props: Props) => {
	const { onAssetLoad, onAssetDelete, userAsset, linkName, disabled } = props;

	const [open, setOpen] = React.useState(false);

	const handleClickOpen = (e: any) => {
		e.preventDefault();
		setOpen(true);
	};
	const handleClose = () => {
		setOpen(false);
	};

	return (
        <div>
			<Typography>
				<Link
        underline='hover'
        style={{color:'#042630'}}
					component="button"
					onClick={(e: any) => {
						handleClickOpen(e);
					}}>
					{userAsset.url.length > 0 ? 'Preview ' + userAsset.type : linkName}
				</Link>
			</Typography>
			<Dialog
				fullWidth
				onClose={handleClose}
				aria-labelledby="customized-dialog-title"
				open={open}>
				<DialogTitle style={{fontSize:'1rem'}}>Thumbnail Selection</DialogTitle>
				<DialogContent
                    dividers
                    classes={{
                        root: classes.root
                    }}>
					<Grid container xs={12}>
						<UploadAsset
							source={{
								fileName: userAsset.originalFileName,
								id: userAsset.id,
								url: userAsset.url,
								duration: userAsset.duration,
								mediaType: 'image',
								uploadStatus: '',
							}}
							handleError={() => {
								console.error('Error');
							}}
							handleDelete={() => {
								onAssetDelete();
							}}
							handleUploadComplete={(result) => {
								onAssetLoad(result);
							}}
							uploadAssetType="advertisement"
							maxVideoTime={0}
							reset={true}
							disabled={disabled}
							handleFileSelected={() => console.log('File Selected')}
						/>
					</Grid>
					<Grid>
						{!userAsset.originalFileName && (
							<ContentLibraryModal
								disabled={disabled}
								mediaType="image"
								handleUploadComplete={(result: FileResult) => {
									onAssetLoad(result);
								}}
							/>
						)}
					</Grid>
				</DialogContent>
				<DialogActions
                    classes={{
                        root: classes.root2
                    }}>
					<Button onClick={handleClose}
          // color="primary"
          style={{color:'#042630'}}
          >
						Close
					</Button>
				</DialogActions>
			</Dialog>
		</div>
    );
};

export default ThumbnailSelector;

const DialogTitle = ((props: any) => {
	const { children,  onClose, ...other } = props;
	return (
        <StyledMuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                    size="large">
					<CloseIcon />
				</IconButton>
			) : null}
		</StyledMuiDialogTitle>
    );
});

const DialogContent = MuiDialogContent;

const DialogActions = MuiDialogActions;
